import { batchList, activeCourseNameList, courseEnrollmentList} from "constants/batch";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addBatch = async (bodyData) => {
  try {
    const res = await api.add_batch(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const getBatchList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_batch_list(pageNum, filters);
    dispatch({ type: batchList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: batchList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getActiveCourseNameList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_active_course_name_list(pageNum, filters);
    dispatch({ type: activeCourseNameList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: activeCourseNameList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getBatchById = async (id) => {
  try {
    const res = await api.get_batch_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateBatchById = async (id, bodyData) => {
  try {
    const res = await api.update_batch_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getCourseEnrollmentList = async (id, dispatch, pageNum, filterParams) => {
  try {
    const res = await api.get_course_enrollment_list(id, pageNum, filterParams);
    dispatch({ type: courseEnrollmentList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: courseEnrollmentList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getInstructorBatchList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_instructor_batch_list(pageNum, filters);
    dispatch({ type: batchList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: batchList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};